jQuery(document).ready(function($) {
    // Use event delegation to avoid re-binding issues
    $(document).on('click', '.episode-ajax-link', function(e) {
        e.preventDefault();

        var page = parseInt($(this).data('page'));
        var blockId = $(this).data('block');
        var container = $('#episodes-container-' + blockId);
        var section = $('#featured-episodes-' + blockId);
        var postId = section.data('post-id');
        var episodesData = section.data('episodes');


        // jQuery should automatically parse the JSON from data attributes
        // If it's still a string, let's try to parse it
        if (typeof episodesData === 'string') {
            try {
                episodesData = JSON.parse(episodesData);
                // console.log('Successfully parsed JSON, now has', episodesData.length, 'episodes');
            } catch (e) {
                // console.log('JSON parse error:', e);
            }
        }

        // Add loading state
        container.addClass('episodes-loading');

        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            type: 'POST',
            data: {
                action: 'load_episodes_ajax',
                page: page,
                episodes_data: JSON.stringify(episodesData),
                block_id: blockId
            },
            success: function(response) {
                // console.log('AJAX Response:', response);

                if (response.success) {
                    // Update episodes
                    container.html(response.data.episodes_html);

                    // Update pagination
                    $('#pagination-' + blockId + ' ul').html(response.data.pagination_html);

                    // Update count
                    $('#episodes-count-' + blockId).html(response.data.count_html);

                    // Smooth scroll to section
                    $('html, body').animate({
                        scrollTop: $('#featured-episode').offset().top - 50
                    }, 500);
                } else {
                    // console.log('Error:', response.data);
                    alert('Error: ' + JSON.stringify(response.data));
                }

                // Remove loading state
                container.removeClass('episodes-loading');
            },
            error: function(xhr, status, error) {
                container.removeClass('episodes-loading');
                // console.log('AJAX Error:', xhr.responseText);
                // alert('Error loading episodes. Please try again.');
            }
        });
    });
});